export default "__VITE_ASSET__DqpEnXDw__"